import React from "react";
import { SettingsContactDetailsScreen } from "~/features/settings/SettingsContactDetailsScreen";

const Component = () => {
  return <SettingsContactDetailsScreen />;
};

export default Component;
